import wrappedAxios from "../axiosWrapper";
import {
  EditRowWithColumns,
  GetTableRowParams,
  TableForJoin,
  TableRowValueDict,
} from "./types";
import * as UP from "./urlParsers";
import { RowKey, TableCells } from "../table/types";
import { TemplateId } from "../../globalTypes";
import { EditRowModel } from "../types";
import { finalizeRequestCreator } from "../finalizeRequestCreator";

// Basic table row stuff
export const getTableRowByTemplateId = ({
  rowKeyValue,
  ...params
}: GetTableRowParams) =>
  wrappedAxios<EditRowWithColumns>({
    url: UP.GetTableRowByTemplateId(rowKeyValue),
    method: "get",
    params: {
      ...params,
    },
  });

export const updateTableRowByTemplateId = (
  rowKeyValue: RowKey,
  templateId: TemplateId,
  cells: TableCells
) =>
  wrappedAxios<EditRowModel>({
    url: UP.UpdateTableRowByTemplateId(rowKeyValue, templateId),
    method: "put",
    data: {
      ...cells,
    },
  });

const getValuesToPrefillBase = (
  templateId: TemplateId,
  formValues: TableRowValueDict
) =>
  wrappedAxios<TableRowValueDict>({
    url: UP.getValuesToPrefill(),
    method: "post",
    params: { templateId },
    data: formValues,
  });

// Takhle bych chtel delat uz vsechny requesty :)
export const getValuesToPrefill = finalizeRequestCreator(
  getValuesToPrefillBase,
  "detail.prefill.singular"
);

export const deleteTableRowByTemplateIdBase = (
  rowKeyValue: RowKey,
  templateId: TemplateId
) =>
  wrappedAxios({
    url: UP.DeleteTableRowByTemplateId(rowKeyValue, templateId),
    method: "delete",
  });

export const deleteTableRowByTemplateId = finalizeRequestCreator(
  deleteTableRowByTemplateIdBase,
  "templateTable.delete.singular"
);

export const addNewTableRowByTemplateId = (
  templateId: TemplateId,
  cells: TableCells
) =>
  wrappedAxios<EditRowWithColumns>({
    url: UP.AddNewTableRowByTemplateId(templateId),
    method: "post",
    data: { ...cells },
  });

export const getEmptyTableRowByTemplateIdBase = (templateId: TemplateId) =>
  wrappedAxios<EditRowWithColumns>({
    url: UP.GetEmptyTableRowByTemplateId(templateId),
    method: "get",
    data: { templateId },
  });

export const getEmptyTableRowByTemplateId = finalizeRequestCreator(
  getEmptyTableRowByTemplateIdBase,
  "table.data.fetch.singular"
);

export const getColumnsWithSelectItemJoins = (
  tableName: string,
  dbContext: string
) =>
  wrappedAxios<TableForJoin>({
    url: UP.GetColumnsWithSelectItemJoins(dbContext, tableName),
  });
